export default "__VITE_ASSET__L2a2k540__"